/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { arrayMove } from "react-sortable-hoc";

/*component */
import LocationInputs from "./LocationInputs";
import SortableGrid from "../../shared/SortableGrid";
import CollectionAccordion from "../../shared/Forms/CollectionAccordion";

class Locations extends Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 0,
			shouldDisable: false,
			expandedIndex: null,
			initialLoad: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.values !== prevProps.values && this.props.values.locations && !this.state.initialLoad) {
			const { locations } = this.props.values;
			this.setState({
				count: locations.length,
				initialLoad: true,
			});
		}
	}

	getOptionsShown = shown => {
		if (shown) {
			this.setState({
				shouldDisable: true,
			});
		} else {
			this.setState({
				shouldDisable: false,
			});
		}
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		const { values, formApi } = this.props;
		if (values && values.locations) {
			const { setValues } = formApi;
			const { locations } = values;
			setValues({
				...values,
				locations: arrayMove(locations, oldIndex, newIndex),
			});
		}
	};

	addLocation = () => {
		const { count } = this.state;
		this.setState({
			count: count + 1,
			expandedIndex: count,
		});
	};

	deleteLocation = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.locations) {
			const { setValues } = formApi;
			const { locations } = values;
			this.setState(
				{
					count: count - 1,
				},
				setValues({
					...values,
					locations: [...locations.slice(0, index), ...locations.slice(index + 1)],
				})
			);
		} else if (count > 0) {
			this.setState({
				count: count - 1,
			});
		}
	};

	copyLocation = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.locations) {
			const { setValues } = formApi;
			const { locations } = values;
			this.setState(
				{
					count: count + 1,
				},
				setValues({
					...values,
					locations: [...locations, locations[index]],
				})
			);
		}
	};

	renderLocations = () => {
		const { locations, values } = this.props;
		const { count, expandedIndex } = this.state;
		const value = values && values.locations ? values.locations : [];
		let locationsElements = [];
		for (var i = 0; i < count; i++) {
			const title = value[i] ? (value[i].title ? value[i].title : value[i].name ? value[i].name : "") : "";
			locationsElements.push(
				<CollectionAccordion
					key={i}
					title={title}
					expanded={expandedIndex === i}
					index={i}
					copyCollection={this.copyLocation}
					deleteCollection={this.deleteLocation}
					toggleCollectionItem={this.toggleCollectionItem}
					getOptionsShown={this.getOptionsShown}
				>
					<LocationInputs locations={locations} index={i} />
				</CollectionAccordion>
			);
		}
		return locationsElements;
	};

	render() {
		const { shouldDisable } = this.state;

		return (
			<div>
				<SortableGrid
					shouldDisable={shouldDisable}
					onSortEnd={this.onSortEnd}
					createNew={this.addLocation}
					title="Session Locations"
				>
					{this.renderLocations()}
				</SortableGrid>
			</div>
		);
	}
}

Locations.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	locations: PropTypes.array,
};

export default Locations;
